export default "__VITE_ASSET__Dn5xPkaZ__"